/*global google*/
import React, { Component } from 'react';
import firebase from '../../helper/firebase';

import isUrl from 'is-url';

import MUIPlacesAutocomplete from 'mui-places-autocomplete';

import { Link } from 'react-router-dom';

import Logo from '../../img/logo.png';

import Head from '../../components/Head';
import LoggedOutCard from '../../components/LoggedOutCard';
import JobCardMedia from '../../components/JobCardMedia';
import JobCardHeader from '../../components/JobCardHeader';
import JobCardContent from '../../components/JobCardContent';
import ViewMoreFeedBtn from '../../components/ViewMoreFeedBtn';
import AddressLinkBar from '../../components/AddressLinkBar';
import UnauthorizedText from '../../components/UnauthorizedText';

import {
	Avatar,
	Button,
	Card,
	CardActions,
	CardContent,
	CardHeader,
	CardMedia,
	CircularProgress,
	Divider,
	LinearProgress,
	List,
	ListItem,
	ListItemIcon,
	ListItemText,
	ListItemSecondaryAction,
	ListSubheader,
	IconButton,
	Paper,
	Switch,
	TextField,
	Typography
} from 'material-ui';
import { MenuItem } from 'material-ui/Menu';

import { FormControlLabel, FormGroup } from 'material-ui/Form';

import CheckIcon from 'material-ui-icons/Check';
import AddAPhotoIcon from 'material-ui-icons/AddAPhoto';
import DeleteIcon from 'material-ui-icons/Delete';

import Fade from 'material-ui/transitions/Fade';

import { ReactGoogleAnalytics } from '../../helper/functions';

import {
	bgWhite,
	// handler,
	LightGray,
	Title
} from '../../helper/consts';

import { SearchGlassdoor } from '../../helper/functions';
import '../../styles/AddJob.css';

const style = {
	loading: {
		alignSelf: 'center',
		width: '75px',
		height: '75px',
		marginTop: 'calc(50vh - 37.5px - 64px)'
	},
	logo: {
		display: 'flex'
	},
	logoAvatar: {
		cursor: 'pointer'
	},
	logoAvatarError: {
		backgroundColor: 'red'
	},
	logoName: {
		backgroundColor: '#eeeeee',
		padding: '0 21px',
		color: 'rgba(135,135,135,1)',
		borderRadius: '3px',
		height: '41px',
		display: 'flex',
		justifyContent: 'center',
		alignItems: 'center',
		marginLeft: '4px'
	},
	logoImageError: {
		color: 'red'
	},
	addImageIcon: {
		color: LightGray,
		transition: 'color 0.3s ease'
	},
	image: {
		maxHeight: '370px',
		minHeight: '244px',
		backgroundPosition: 'center',
		backgroundSize: 'cover',
		height: '33vw',
		display: 'flex',
		justifyContent: 'center',
		alignItems: 'center',
		backgroundColor: bgWhite,
		cursor: 'pointer'
	},
	jobDetailsTitle: {
		marginTop: '11px'
	},
	jobDetailsText: {
		marginBottom: '11px'
	},
	jobActions: {
		marginBotton: '5px'
	},
	newListItemContainer: {
		display: 'flex',
		alignItems: 'flex-end'
	},
	socialLinks: {
		display: 'flex',
		flexWrap: 'wrap'
	},
	socialInput: {
		marginRight: '30px',
		width: '30%',
		minWidth: '330px'
	}
};

const initState = {
	loggedIn: false,
	authLoading: true,
	company: '',
	about: '',
	details: ``,
	responsibilities: [],
	newResponsibility: '',
	qualifications: [],
	newQualification: '',
	location: '',
	title: '',
	glassdoorId: '',
	publicJob: false,
	privateCompanyStats: false,
	privateOfferStats: false,
	companyURI: '',
	commission: 1000,
	logoFileUrl: '',
	imageFileUrl: '',
	companies: []
};

export default class AddJob extends Component {
	constructor(props) {
		super(props);

		this.state = initState;
	}

	static getDerivedStateFromProps(nextProps, prevState) {
		if (!nextProps.loggedin) {
			return initState;
		} else {
			return null;
		}
	}

	renderPreview = () => {
		const {
			company,
			companyURI,
			title,
			location,
			details,
			responsibilities,
			logoFileUrl,
			imageFileUrl,
			qualifications
		} = this.state;
		const job = {
			company,
			companyURI,
			title,
			location,
			details,
			responsibilities,
			qualifications,
			image: {
				downloadURLs: [imageFileUrl]
			},
			logo: {
				downloadURLs: [logoFileUrl]
			}
		};
		let html = [];
		let card = (
			<Fade in={true}>
				<Card key={'preview'} className="card">
					{!!job.image && <JobCardMedia job={job} />}
					<JobCardHeader job={job} />
					<Divider light />
					<JobCardContent job={job} />
					<Divider light />
					<AddressLinkBar location={job.location} />
				</Card>
			</Fade>
		);
		html.push(card);
		return html;
	};

	clearErrors = () => {
		this.setState({
			facebookError: false,
			twitterError: false,
			linkedinError: false,
			imageError: false,
			logoError: false,
			companyError: false,
			aboutError: false,
			titleError: false,
			locationError: false,
			detailsError: false,
			glassdoorIdError: false,
			commissionError: false
		});
	};

	checkCompanyURI = event => {
		let status = isUrl(event.target.value);
		this.setState({ companyURIError: !status });
		this.clearErrors();
	};

	handleFormInput = (e, formField) => {
		this.setState({ [`${formField}`]: e.target.value });
		if (formField === 'company') {
			this.setState({ searchingCompany: true });
			SearchGlassdoor(e.target.value)
				.then(data => {
					if (!!data && !!data.response && !!data.response.employers) {
						this.setState({ companies: data.response.employers });
					}
				})
				.catch(error => {
					this.setState({ searchingCompany: false });
				});
		}
		this.clearErrors();
	};

	saveNewQualificationWithEnter = e =>
		e.key === 'Enter' && this.saveNewQualification();

	saveNewRequirementWithEnter = e =>
		e.key === 'Enter' && this.saveNewResponsibility();

	renderAddJobForm = () => {
		let html = [];
		let card = (
			<Fade key="ApplicationForm" in={true}>
				<Card className="card">
					{this.props.loggedIn && (
						<CardHeader
							avatar={
								<Avatar
									aria-label={this.props.auth.displayName}
									src={this.props.auth.photoURL}
								/>
							}
							title={this.props.auth.displayName}
							subheader={this.props.auth.email}
						/>
					)}
					<Divider light />
					<div className="blackOnHover" style={style.addImageIcon}>
						<input
							onChange={this.handleImageSelect}
							accept="image"
							style={{ display: 'none' }}
							id="image"
							multiple
							type="file"
						/>
						<label htmlFor="image">
							<CardMedia
								image={this.state.imageFileUrl || '...'}
								title={'Add A Banner Image'}
								style={style.image}
							>
								{!this.state.imageFileUrl && <AddAPhotoIcon />}
								<Typography
									style={this.state.imageError ? style.logoImageError : null}
								>
									{this.state.imageError ? '*' : null}
								</Typography>
							</CardMedia>
						</label>
					</div>
					<CardContent>
						<div style={style.logo} className="logo">
							<input
								onChange={this.handleLogoSelect}
								accept="image"
								style={{ display: 'none' }}
								id="logo"
								multiple
								type="file"
							/>
							<label style={{ display: 'flex' }} htmlFor="logo">
								<Avatar
									src={this.state.logoFileUrl}
									style={
										this.state.logoError
											? style.logoAvatarError
											: style.logoAvatar
									}
								>
									{!this.state.logoFileUrl && <AddAPhotoIcon />}
								</Avatar>
								<Typography
									style={this.state.logoError ? style.logoImageError : null}
								>
									*Logo
								</Typography>
								{this.state.logoFilename ? (
									<Typography
										style={style.logoName}
										align="left"
										color="inherit"
										type="body2"
									>
										Filename: {this.state.logoFilename}
									</Typography>
								) : (
									<Typography
										style={style.logoName}
										align="left"
										color="inherit"
										type="body2"
									>
										Upload Logo file (max 3mb)
									</Typography>
								)}
							</label>
						</div>
						<TextField
							disabled={this.state.posted || this.state.posting}
							error={this.state.companyError}
							required
							fullWidth
							id="company"
							label="Company Name"
							value={this.state.company}
							onChange={e => {
								this.handleFormInput(e, 'company');
							}}
							margin="normal"
						/>
						{this.state.searchingCompany && (
							<Fade in={true}>
								<Paper>
									{this.state.companies.length === 0 ? (
										<LinearProgress />
									) : (
										this.state.companies.map((company, i) => {
											return (
												<MenuItem
													key={company.id}
													component="div"
													onClick={() => {
														this.selectCompany(i);
													}}
													selected={company.exactMatch}
													style={{
														fontWeight: 400
													}}
												>
													<Avatar
														style={{ marginRight: '10px' }}
														src={company.squareLogo}
													/>
													<Typography>{company.name}</Typography>
												</MenuItem>
											);
										})
									)}
									{this.state.companies !== 0 && (
										<MenuItem
											key={'typed_company_name'}
											component="div"
											onClick={() => {
												this.setState({
													glassdoorId: '',
													companyURI: '',
													searchingCompany: false
												});
											}}
											style={{
												fontWeight: 500
											}}
										>
											'{this.state.company}'
										</MenuItem>
									)}
								</Paper>
							</Fade>
						)}
						<TextField
							disabled={this.state.posted || this.state.posting}
							error={this.state.aboutError}
							required
							fullWidth
							id="about"
							label="About Company"
							multiline
							value={this.state.about}
							onChange={e => {
								this.handleFormInput(e, 'about');
							}}
							margin="normal"
						/>
						<TextField
							disabled={this.state.posted || this.state.posting}
							error={this.state.titleError}
							required
							fullWidth
							id="title"
							label="Title"
							value={this.state.title}
							onChange={e => {
								this.handleFormInput(e, 'title');
							}}
							margin="normal"
						/>

						<MUIPlacesAutocomplete
							onSuggestionSelected={suggestion => this.setLocation(suggestion)}
							renderTarget={() => <span />}
							createAutocompleteRequest={inputValue => {
								return {
									input: inputValue,
									types: ['geocode'],
									location: { lat: () => 43.650479, lng: () => -79.391301 },
									radius: 50000
								};
							}}
							textFieldProps={{
								// error: self.state.addressError,
								required: true,
								fullWidth: true,
								id: 'address',
								label: 'Location',
								// value:self.state.address,
								margin: 'normal',
								placeholder: '111 Richmond Street West, Toronto, Ontario'
							}}
						/>

						<TextField
							disabled={this.state.posted || this.state.posting}
							error={this.state.detailsError}
							required
							fullWidth
							id="details"
							label="Job Details"
							multiline
							value={this.state.details}
							onChange={e => {
								this.handleFormInput(e, 'details');
							}}
							margin="normal"
						/>
						<TextField
							disabled={this.state.posted || this.state.posting}
							type="number"
							error={this.state.glassdoorIdError}
							fullWidth
							id="glassdoorId"
							label="Glassdoor ID"
							value={this.state.glassdoorId}
							onChange={e => {
								this.handleFormInput(e, 'glassdoorId');
							}}
							margin="normal"
						/>
						<List>
							{this.state.responsibilities.length > 0 && (
								<ListSubheader>{`Job Responsibilities`}</ListSubheader>
							)}
							{this.state.responsibilities.map((responsibility, i) => {
								return (
									<ListItem key={i} dense>
										<ListItemIcon>
											<CheckIcon />
										</ListItemIcon>
										<ListItemText primary={`${responsibility}`} />
										<ListItemSecondaryAction>
											<IconButton
												disabled={this.state.posted || this.state.posting}
												onClick={() => {
													this.deleteResponsibility(i);
												}}
												aria-label="Delete"
											>
												<DeleteIcon />
											</IconButton>
										</ListItemSecondaryAction>
									</ListItem>
								);
							})}
						</List>
						<div style={style.newListItemContainer}>
							<TextField
								disabled={this.state.posted || this.state.posting}
								error={this.state.responsibilitiesError}
								fullWidth
								id="responsibilities"
								label="Add Responsibility"
								value={this.state.newResponsibility}
								onChange={e => {
									this.handleFormInput(e, 'newResponsibility');
								}}
								onKeyPress={this.saveNewRequirementWithEnter}
								margin="normal"
							/>
							<Button
								aria-label="Save"
								disabled={this.state.newResponsibility.length === 0}
								onClick={this.saveNewResponsibility}
								color="primary"
							>
								<CheckIcon />
							</Button>
						</div>
						<List>
							{this.state.qualifications.length > 0 && (
								<ListSubheader>{`Candidate Qualifications`}</ListSubheader>
							)}
							{this.state.qualifications.map((qualification, i) => {
								return (
									<ListItem key={i} dense>
										<ListItemIcon>
											<CheckIcon />
										</ListItemIcon>
										<ListItemText primary={`${qualification}`} />
										<ListItemSecondaryAction>
											<IconButton
												disabled={this.state.posted || this.state.posting}
												onClick={() => {
													this.deleteQualification(i);
												}}
												aria-label="Delete"
											>
												<DeleteIcon />
											</IconButton>
										</ListItemSecondaryAction>
									</ListItem>
								);
							})}
						</List>
						<div style={style.newListItemContainer}>
							<TextField
								disabled={this.state.posted || this.state.posting}
								error={this.state.qualificationsError}
								fullWidth
								id="qualifications"
								label="Add Qualification"
								value={this.state.newQualification}
								onChange={e => {
									this.handleFormInput(e, 'newQualification');
								}}
								onKeyPress={this.saveNewQualificationWithEnter}
								margin="normal"
							/>
							<Button
								aria-label="Save"
								disabled={this.state.newQualification.length === 0}
								onClick={this.saveNewQualification}
								color="primary"
							>
								<CheckIcon />
							</Button>
						</div>
						<TextField
							disabled={this.state.posted || this.state.posting}
							error={this.state.companyURIError}
							fullWidth
							id="companyURI"
							label="Company URI"
							placeholder={`https://www.${Title}.com`}
							helperText={
								this.state.companyURIError
									? `Please enter a valid URI in the form: https://www.${Title}.com`
									: null
							}
							value={this.state.companyURI}
							onChange={event => {
								this.setState({ companyURI: event.target.value });
								this.checkCompanyURI(event);
							}}
							margin="normal"
						/>
						<TextField
							disabled={this.state.posted || this.state.posting}
							error={this.state.commissionError}
							fullWidth
							id="commission"
							label="Commission"
							required
							type="number"
							helperText={
								this.state.commissionError
									? `Please enter a valid commission amount, with a minimum 1,000.`
									: null
							}
							value={this.state.commission}
							onChange={e => {
								this.handleFormInput(e, 'commission');
							}}
							margin="normal"
						/>
						<FormGroup>
							<FormControlLabel
								control={
									<Switch
										disabled={this.state.posted || this.state.posting}
										checked={this.state.privateCompanyStats}
										onChange={(event, checked) =>
											this.setState({ privateCompanyStats: checked })
										}
									/>
								}
								label="Hide Company Stats"
							/>
						</FormGroup>
					</CardContent>
					{this.state.uploadProgress > 0 &&
						this.state.uploadProgress < 100 && (
							<LinearProgress
								color="accent"
								mode="determinate"
								value={this.state.uploadProgress}
							/>
						)}
					<CardActions className="cardActions" style={style.jobActions}>
						{this.state.posted ? (
							<Link
								className="cardActionsBtn"
								color="accent"
								to={`/Offer/${this.state.oid}`}
							>
								<Button raised>Go To Job</Button>
							</Link>
						) : (
							<Link className="cardActionsBtn" to={`/Jobs`}>
								<Button
									disabled={this.state.posting || this.state.posted}
									raised
								>
									Cancel
								</Button>
							</Link>
						)}
						<Button
							className="cardActionsBtn"
							disabled={this.state.posting}
							onClick={!this.state.posted ? this.validate : null}
							raised={!this.state.posted}
							color={this.state.posted ? 'accent' : 'primary'}
						>
							{this.state.posted ? (
								<CheckIcon />
							) : this.state.posting ? (
								'Posting'
							) : (
								'$499 Post'
							)}
						</Button>
					</CardActions>
				</Card>
			</Fade>
		);
		html.push(card);
		return html;
	};

	setLocation = location => {
		this.setState({ location: location.description });
		let geocoder = new google.maps.Geocoder();
		geocoder.geocode({ address: location.description }, (results, status) => {
			if (
				status === 'OK' &&
				!!results[0] &&
				!!results[0].geometry &&
				!!results[0].geometry.location
			) {
				console.log(results[0]);
				let lat = results[0].geometry.location.lat();
				let lng = results[0].geometry.location.lng();
				this.setState({ geopoint: new firebase.firestore.GeoPoint(lat, lng) });
			}
			if (
				status === 'OK' &&
				!!results[0] &&
				!!results[0].address_components &&
				!!results[0].address_components
			) {
				let address = {};
				results[0].address_components.forEach(component => {
					if (component.types.indexOf('street_number') !== -1) {
						address.street_number = component.long_name;
					}
					if (component.types.indexOf('route') !== -1) {
						address.route = component.long_name;
					}
					if (component.types.indexOf('locality') !== -1) {
						address.locality = component.long_name;
					}
					if (component.types.indexOf('administrative_area_level_1') !== -1) {
						address.administrative_area_level_1 = component.short_name;
					}
					if (component.types.indexOf('country') !== -1) {
						address.country = component.short_name;
					}
					if (component.types.indexOf('postal_code') !== -1) {
						address.postal_code = component.long_name;
					}
				});
				this.setState({ address });
			}
		});
	};

	selectCompany = i => {
		this.setState({
			company: this.state.companies[i].name,
			glassdoorId: this.state.companies[i].id,
			searchingCompany: false,
			companyURI: this.state.companies[i].website || '',
			companies: []
		});
	};

	deleteQualification = i => {
		let { qualifications } = this.state;
		qualifications.splice(i, 1);
		this.setState({ qualifications });
	};

	saveNewQualification = () => {
		let { newQualification, qualifications } = this.state;
		if (newQualification.length === 0) {
			this.props.actions.setSnack(
				true,
				'Error: Please enter text to add to qualifications.'
			);
			return;
		}
		qualifications.push(newQualification);
		this.setState({ qualifications, newQualification: '' });
	};

	deleteResponsibility = i => {
		let { responsibilities } = this.state;
		responsibilities.splice(i, 1);
		this.setState({ responsibilities });
	};

	saveNewResponsibility = () => {
		let { newResponsibility, responsibilities } = this.state;
		if (newResponsibility.length === 0) {
			this.props.actions.setSnack(
				true,
				'Error: Please enter text to add to responsibilities.'
			);
			return;
		}
		responsibilities.push(newResponsibility);
		this.setState({ responsibilities, newResponsibility: '' });
	};

	handleLogoSelect = e => {
		let file = e.target.files[0];
		if (file) {
			if (!file.type.match('image')) {
				this.props.actions.setSnack(
					true,
					'Error: Please upload (png,jpg,jpeg)'
				);
				this.setState({ logoError: true });
			} else if (file.size > 3000000) {
				this.props.actions.setSnack(true, 'Maximum Logo size (3mb) exceeded.');
				this.setState({ logoError: true });
			} else {
				let reader = new FileReader(file);
				reader.onloadend = () => {
					this.setState({
						logoFile: file,
						logoFilename: file.name,
						logoFileUrl: reader.result,
						logoError: false,
						imageError: false
					});
				};
				if (!!file) {
					reader.readAsDataURL(file);
				}
				// file!==undefined?reader.readAsDataURL(file):null
			}
		}
	};

	handleImageSelect = e => {
		let file = e.target.files[0];
		if (file) {
			if (!file.type.match('image')) {
				this.props.actions.setSnack(
					true,
					'Error: Please upload (png,jpg,jpeg)'
				);
				this.setState({ imageError: true });
			} else if (file.size > 3000000) {
				this.props.actions.setSnack(true, 'Maximum Image size (3mb) exceeded.');
				this.setState({ imageError: true });
			} else {
				let reader = new FileReader(file);
				reader.onloadend = () => {
					this.setState({
						imageFile: file,
						imageFilename: file.name,
						imageFileUrl: reader.result,
						imageError: false,
						logoError: false
					});
				};
				if (!!file) {
					reader.readAsDataURL(file);
				}
				// file!==undefined?reader.readAsDataURL(file):null
			}
		}
	};

	validate = () => {
		if (!this.state.imageFilename || this.state.imageFilename.length < 1) {
			this.validationError('Error: Please upload a banner image', 'image');
		} else if (
			this.state.imageFile &&
			!(
				this.state.imageFile.type === 'image/png' ||
				this.state.imageFile.type === 'image/jpg' ||
				this.state.imageFile.type === 'image/jpeg'
			)
		) {
			this.validationError('Error: Please upload an image', 'image');
		} else if (!this.state.logoFilename || this.state.logoFilename.length < 1) {
			this.validationError('Error: Please upload a logo', 'logo');
		} else if (
			this.state.logoFile &&
			!(
				this.state.logoFile.type === 'image/png' ||
				this.state.logoFile.type === 'image/jpg' ||
				this.state.logoFile.type === 'image/jpeg'
			)
		) {
			this.validationError('Error: Please upload a logo', 'logo');
		} else if (this.state.company.length < 1) {
			this.validationError('Error: Please upload a company name', 'company');
		} else if (this.state.about.length < 1) {
			this.validationError('Error: Please enter company details', 'about');
		} else if (this.state.title.length < 1) {
			this.validationError('Error: Please enter a job title', 'title');
		} else if (this.state.location.length < 1) {
			this.validationError('Error: Please enter a job location', 'location');
		} else if (this.state.details.length < 1) {
			this.validationError('Error: Please enter job details', 'details');
		} else if (this.state.commission.length < 1) {
			this.validationError(
				'Error: Please enter a commission greater than 1000',
				'commission'
			);
		} else if (!(this.state.commission >= 1000)) {
			this.validationError(
				'Error: Please enter a commission greater than 1000',
				'commission'
			);
		} else {
			this.configurePaymentHandler();
		}
	};

	validationError = (error, state) => {
		this.props.actions.setSnack(true, error);
		this.setState({ [`${state}Error`]: true });
	};

	payment = token => {
		this.setState({ posting: true, uploadProgress: 1 });
		var purchase = firebase.functions().httpsCallable('purchase');
		const jobsObj = {
			about: this.state.about.replace(/\n/g, '\r\n'),
			address: this.state.address,
			commission: this.state.commission,
			company: this.state.company,
			companyURI: this.state.companyURI,
			created: Date.now(),
			details: this.state.details,
			geopoint: this.state.geopoint,
			glassdoorId: this.state.glassdoorId,
			location: this.state.location,
			privateCompanyStats: this.state.privateCompanyStats,
			privateOfferStats: this.state.privateOfferStats,
			publicJob: this.state.publicJob,
			qualifications: this.state.qualifications,
			responsibilities: this.state.responsibilities,
			title: this.state.title
		};
		purchase({
			token: token,
			job: jobsObj
		})
			.then(result => {
				this.setState({ posting: true, uploadProgress: 50 });
				ReactGoogleAnalytics('Posting', 'Purchase', this.props.uid, null, null);
				this.uploadLogoAndImage(result.data);
			})
			.catch(error => this.uploadError(error));
	};

	uploadError = error => {
		console.log(error);
		this.props.actions.setSnack(true, `There was an error. Please try again.`);
		this.setState({ posting: false, posted: false, uploadProgress: 0 });
	};

	uploadLogoAndImage = data => {
		const { jid, oid } = data;
		const { uid } = this.props;
		let { imageFile, logoFile } = this.state;
		let self = this;
		const storageRef = firebase.storage().ref();

		const imageMeta = { customMetadata: { name: imageFile.name, uid, jid } };
		const imageStorageRef = storageRef.child(`jobs/${uid}/${jid}/${jid}_image`);
		const imageUploadTask = imageStorageRef.put(imageFile, imageMeta);

		const logoMeta = { customMetadata: { name: logoFile.name, uid, jid } };
		const logoStorageRef = storageRef.child(`jobs/${uid}/${jid}/${jid}_logo`);
		const logoUploadTask = logoStorageRef.put(logoFile, logoMeta);

		imageUploadTask.on(
			'state_changed',
			imageSnapshot => {
				self.setState({
					uploadProgress:
						imageSnapshot.bytesTransferred /
							imageSnapshot.totalBytes /
							4 *
							100 +
						self.state.uploadProgress
				});
			},
			imageErr => self.uploadError(imageErr),
			imageComplete => {
				let imageObject = {};
				imageStorageRef
					.getMetadata()
					.then(metadata => {
						imageObject.filename = metadata.customMetadata.name;
						imageObject.bucket = metadata.bucket;
						imageObject.contentType = metadata.contentType;
						imageObject.fullPath = metadata.fullPath;
						imageObject.name = metadata.name;
						imageObject.size = metadata.size;
						imageObject.timeCreated = metadata.timeCreated;
						imageObject.updated = metadata.updated;
						imageObject.downloadURLs = metadata.downloadURLs;
						firebase
							.firestore()
							.collection('jobs')
							.doc(jid)
							.update({ image: imageObject })
							.then(() => {
								self.setState({ imageUploaded: true });
								if (self.state.logoUploaded) {
									self.setState({ initState });
									self.setState({ posted: true });
									ReactGoogleAnalytics('Jobs', 'Create', jid, null, null);
									self.props.history.push(`/BatchInvite/${oid}`);
								}
							})
							.catch(imageUploadError => self.uploadError(imageUploadError));
					})
					.catch(uploadError => self.uploadError(uploadError));
			}
		);

		logoUploadTask.on(
			'state_changed',
			logoSnapshot => {
				self.setState({
					uploadProgress:
						logoSnapshot.bytesTransferred / logoSnapshot.totalBytes / 4 * 100 +
						self.state.uploadProgress
				});
			},
			logoErr => self.uploadError(logoErr),
			logoComplete => {
				let logoObject = {};
				logoStorageRef
					.getMetadata()
					.then(metadata => {
						logoObject.filename = metadata.customMetadata.name;
						logoObject.bucket = metadata.bucket;
						logoObject.contentType = metadata.contentType;
						logoObject.fullPath = metadata.fullPath;
						logoObject.name = metadata.name;
						logoObject.size = metadata.size;
						logoObject.timeCreated = metadata.timeCreated;
						logoObject.updated = metadata.updated;
						logoObject.downloadURLs = metadata.downloadURLs;
						firebase
							.firestore()
							.collection('jobs')
							.doc(jid)
							.update({ logo: logoObject })
							.then(() => {
								self.setState({ logoUploaded: true });
								if (self.state.imageUploaded) {
									self.setState({ initState });
									self.setState({ posted: true });
									ReactGoogleAnalytics('Jobs', 'Create', jid, null, null);
									self.props.history.push(`/BatchInvite/${oid}`);
								}
							})
							.catch(logoUploadError => self.uploadError(logoUploadError));
					})
					.catch(uploadError => self.uploadError(uploadError));
			}
		);
	};

	configurePaymentHandler = () => {
		const handler = window.StripeCheckout.configure({
			key: 'pk_test_v2TzNljZwdJG6mw53JiRpxwu',
			image: Logo,
			locale: 'auto',
			token: token => {
				this.payment(token.id);
			}
		});
		this.showPaymentUI(handler);
	};

	showPaymentUI = handler => {
		// Open Checkout with further options:
		handler.open({
			name: 'UNEAU',
			description: 'Single Post Purchase',
			email: this.props.auth.email,
			opened: () => {
				ReactGoogleAnalytics('Posting', 'Open', this.props.uid, null, null);
			},
			closed: () => {
				ReactGoogleAnalytics('Posting', 'Close', this.props.uid, null, null);
			},
			currency: 'cad',
			amount: 56387
		});
		this.registerCheckoutCloseListener(handler);
	};

	registerCheckoutCloseListener = handler => {
		window.addEventListener('popstate', () => {
			handler.close();
		});
	};

	render() {
		return (
			<React.Fragment>
				<Head title={`Add Job | ${Title}`} />
				<div id={this.props.loggedIn ? 'loggedInBody' : null} className="body">
					{this.props.authLoading && (
						<CircularProgress style={style.loading} size={75} />
					)}
					{!this.props.authLoading &&
						this.props.admin &&
						this.props.loggedIn &&
						this.renderAddJobForm()}
					{!this.props.authLoading &&
						this.props.admin &&
						this.props.loggedIn && (
							<ViewMoreFeedBtn
								key={'view preview'}
								onClickfunction={() => {
									this.setState({ viewPreview: !this.state.viewPreview });
								}}
								text={this.state.viewPreview ? 'Hide Prevew' : 'View Preview'}
							/>
						)}
					{!this.props.authLoading &&
						this.props.loggedIn &&
						this.state.viewPreview &&
						this.props.admin &&
						this.renderPreview()}
					{!this.props.authLoading &&
						this.props.loggedIn &&
						!this.props.adminLoading &&
						!this.props.admin && (
							<div className="unauthorizedTextContainer">
								<UnauthorizedText
									text="Unauthorized"
									subText="Access is limited"
								/>
							</div>
						)}

					{!this.props.authLoading && !this.props.loggedIn && <LoggedOutCard />}
				</div>
			</React.Fragment>
		);
	}
}



// WEBPACK FOOTER //
// ./src/pages/AddJob/AddJob.js